import React from 'react'
import Modal from 'react-modal';
import Iframe from 'react-iframe'

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

Modal.setAppElement('#root');
const PreviewMultimediaIframeModal = ({ modalIframeIsOpen, closeModal, previewFormData }) => {

  let subtitle;

  function afterOpenModal() {
    
    subtitle.style.color = "#f00";
  }

  return (
    <div>
      <Modal
        isOpen={modalIframeIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Previsualización Iframe"
      >
        <div>Previsualización Iframe</div>
        <form>
          <Iframe url={previewFormData.url}
            width="444px"
            height="250px"
            id=""
            className=""
            display="block"
            position="relative" />
        </form>
      </Modal>
    </div>
  )
}

export default PreviewMultimediaIframeModal